import React from 'react';
import PropTypes from 'prop-types';
import Im from 'immutable';
import CustomSwaggerStylesContainer from './CustomSwaggerStylesContainer';
import DOperationTag from './DOperationTag';
import TryItOutContainer from './TryItOutContainer';
import RiskLevel from '../types/RiskLevel';
import { SWAGGER_EXTENSIONS } from './tryItOut/constants';

export default class DOperations extends React.Component<any> {
  static propTypes = {
    specSelectors: PropTypes.object.isRequired,
    specActions: PropTypes.object.isRequired,
    oas3Actions: PropTypes.object.isRequired,
    getComponent: PropTypes.func.isRequired,
    oas3Selectors: PropTypes.func.isRequired,
    layoutSelectors: PropTypes.object.isRequired,
    layoutActions: PropTypes.object.isRequired,
    authActions: PropTypes.object.isRequired,
    authSelectors: PropTypes.object.isRequired,
    getConfigs: PropTypes.func.isRequired,
    fn: PropTypes.func.isRequired,
  };

  // Session-level flag for high-risk warning dialog acceptance
  isHighRiskWarningDialogAccepted = false;

  highRiskWarningDialog = {
    isAccepted: () => this.isHighRiskWarningDialogAccepted,
    setAccepted: (value: boolean) => {
      this.isHighRiskWarningDialogAccepted = value;
    },
  };

  renderOperationTag = (tagObj: Im.Map<string, any>, tag: string) => {
    const {
      specSelectors,
      getComponent,
      oas3Selectors,
      layoutSelectors,
      layoutActions,
      getConfigs,
    } = this.props;
    const validOperationMethods = specSelectors.validOperationMethods();
    const OperationContainer = getComponent('OperationContainer', true);
    const operations: Im.List<Im.Map<string, any>> = tagObj.get('operations');

    return (
      <DOperationTag
        key={`operation-${tag}`}
        tagObj={tagObj}
        tag={tag}
        oas3Selectors={oas3Selectors}
        layoutSelectors={layoutSelectors}
        layoutActions={layoutActions}
        getConfigs={getConfigs}
        getComponent={getComponent}
        specUrl={specSelectors.url()}>
        <div className='operation-tag-content'>
          {operations
            .map((op: any) => {
              const path = op.get('path');
              const method = op.get('method');
              const specPath = Im.List(['paths', path, method]);

              if (validOperationMethods.indexOf(method) === -1) {
                return null;
              }

              const hasSupportedAuthTypes = op.getIn([
                'operation',
                SWAGGER_EXTENSIONS.TRY_IT_OUT_HAS_SUPPORTED_AUTH_TYPES,
              ]);
              const rawRiskLevel = op.getIn([
                'operation',
                SWAGGER_EXTENSIONS.TRY_IT_OUT_RISK_LEVEL,
              ]);
              const riskLevel = Object.values(RiskLevel).includes(rawRiskLevel as RiskLevel)
                ? (rawRiskLevel as RiskLevel)
                : RiskLevel.CRITICAL;
              const url = op.getIn(['operation', SWAGGER_EXTENSIONS.TRY_IT_OUT_URL]);

              const operationContainer = (
                <OperationContainer
                  {...this.props}
                  key={`${path}-${method}`}
                  specPath={specPath}
                  op={op}
                  path={path}
                  method={method}
                  tag={tag}
                />
              );

              if (process.env.enableTryItOut) {
                return (
                  <CustomSwaggerStylesContainer key={`${path}-${method}-container`}>
                    <TryItOutContainer
                      hasSupportedAuthTypes={hasSupportedAuthTypes}
                      riskLevel={riskLevel}
                      method={method.toUpperCase()}
                      url={url}
                      highRiskWarningDialog={this.highRiskWarningDialog}>
                      {operationContainer}
                    </TryItOutContainer>
                  </CustomSwaggerStylesContainer>
                );
              }

              return (
                <CustomSwaggerStylesContainer key={`${path}-${method}-container`}>
                  {operationContainer}
                </CustomSwaggerStylesContainer>
              );
            })
            .toArray()}
        </div>
      </DOperationTag>
    );
  };

  render() {
    const { specSelectors } = this.props;

    const taggedOps = specSelectors.taggedOperations();

    if (taggedOps.size === 0) {
      return <h3> No operations defined in spec!</h3>;
    }

    return (
      <div>
        {taggedOps.map(this.renderOperationTag).toArray()}
        {taggedOps.size < 1 ? <h3>None</h3> : null}
      </div>
    );
  }
}
